import { render, staticRenderFns } from "./InfoUsuarioVapp.vue?vue&type=template&id=2e4f4e8e&scoped=true"
import script from "./InfoUsuarioVapp.vue?vue&type=script&lang=js"
export * from "./InfoUsuarioVapp.vue?vue&type=script&lang=js"
import style0 from "./InfoUsuarioVapp.vue?vue&type=style&index=0&id=2e4f4e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f4e8e",
  null
  
)

export default component.exports